import React from "react";
import { Toggle, ToggleColor } from "../../../../Forms/Inputs/Toggle/React";
import { useTranslationContext } from "../../context";

interface RememberDetailsProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

export const RememberDetails = ({ checked, onChange }: RememberDetailsProps) => {
  const translation = useTranslationContext();

  return (
    <Toggle
      label={translation?.translations?.rememberMyDetails}
      name="remember-my-details"
      color={ToggleColor.Neutral}
      checked={checked}
      onChange={onChange}
    />
  );
};

RememberDetails.displayName = "RememberDetails";

export default RememberDetails;
